module.exports = __webpack_public_path__ + "img/rdw-3.620e0a61.jpg";